// Auth Paths
export const AUTH_VERIFY_OTP = '/auth/verify-otp';
export const AUTH_COMPLETE_ACCOUNT = '/auth/complete-account';

// Event Paths
export const EVENTS_DETAIL = '/events/detail/:event_code';
export const EVENTS_ALBUM = '/events/album/:event_code';
export const EVENTS_JOIN = '/events/join/:event_code';
export const EVENTS_UPLOAD_JOIN = '/events/upload-join/:event_code';
export const EVENTS_INVITATION_ACCEPT = '/events/invitation/accept/:event_code';

// QR Flow Path
export const UPLOAD_EVENT_IMAGES = '/upload-event-images/:event_code';
export const USER_UPLOADED_IMAGES = '/user-uploaded-images';

// Core Paths
export const HOME = '/';
export const LOGIN = '/login';

export const PROFILE = '/profile';
export const ACCOUNT_DELETION = '/account-deletion/';
